<template>
  <div
    style="width: 100%"
    class="mx-2"
  >
    <v-col cols="12">
      <app-title texto="ATIVIDADES DE INTERESSE" />
    </v-col>
    <v-col
      v-for="f in filtro"
      :key="f.titulo"
      cols="12"
    >
      <filtro-base :value="f" />
    </v-col>
  </div>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import FiltroBase from '@/components/monitoramento/perfil/filtro/base/FiltroBase';
import FiltroPerfil from '@/modules/filtroPerfil';

export default {
  name: 'FiltroAtividadeInteresse',

  components: { AppTitle, FiltroBase },

  data() {
    return {
      filtro: {
        interesse: {
          habilitado: true,
          filhos: [
            {
              id: 'areasCultura',
              tipo: 'select',
              titulo: 'Áreas de Cultura e Arte',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaAreasCultura.filter((c) => c.id),
              itemText: 'nome',
              icone: 'palette',
              multiplo: true,
              todas: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'areasEsporte',
              tipo: 'select',
              titulo: 'Áreas de Esporte',
              habilitado: false,
              selecionado: [],
              lista: this.$store.state.perfil.listaAreasEsporte.filter((c) => c.id),
              itemText: 'nome',
              icone: 'directions_bike',
              multiplo: true,
              todas: true,
              colunas: 6,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Outro(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'instrutorCultura',
              tipo: 'confirm',
              titulo: 'Instrutor de Cultura e Arte?',
              habilitado: false,
              opcoes: [
                { nome: 'Sim', valor: true },
                { nome: 'Não', valor: false },
              ],
              opcao: null,
              horizontal: true,
              colunas: 6,
              filhosDependentes: true,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Curso(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
            {
              id: 'instrutorEsporte',
              tipo: 'confirm',
              titulo: 'Instrutor de Esporte?',
              habilitado: false,
              opcoes: [
                { nome: 'Sim', valor: true },
                { nome: 'Não', valor: false },
              ],
              opcao: null,
              horizontal: true,
              colunas: 6,
              filhosDependentes: true,
              filhos: [
                {
                  id: 'outros',
                  tipo: 'extra',
                  titulo: 'Pesquisar Curso(s)',
                  opcao: false,
                  outros: null,
                },
              ],
            },
          ],
        },
      },
    };
  },

  watch: {
    filtro: {
      handler(value) {
        const filtroAreasCultura = FiltroPerfil.get('areasCultura', value.interesse.filhos);
        const filtroAreasCulturaOutros = FiltroPerfil.get('outros', filtroAreasCultura.filhos);
        const filtroAreasEsporte = FiltroPerfil.get('areasEsporte', value.interesse.filhos);
        const filtroAreasEsporteOutros = FiltroPerfil.get('outros', filtroAreasEsporte.filhos);
        const filtroInstrutorCultura = FiltroPerfil.get('instrutorCultura', value.interesse.filhos);
        const filtroInstrutorCulturaOutros = FiltroPerfil.get('outros', filtroInstrutorCultura.filhos);
        const filtroInstrutorEsporte = FiltroPerfil.get('instrutorEsporte', value.interesse.filhos);
        const filtroInstrutorEsporteOutros = FiltroPerfil.get('outros', filtroInstrutorEsporte.filhos);

        const retorno = {
          areasCultura: {
            ...FiltroPerfil.getRetorno(filtroAreasCultura),
            outros: FiltroPerfil.getRetorno(filtroAreasCulturaOutros),
          },
          areasEsporte: {
            ...FiltroPerfil.getRetorno(filtroAreasEsporte),
            outros: FiltroPerfil.getRetorno(filtroAreasEsporteOutros),
          },
          instrutorCultura: {
            ...FiltroPerfil.getRetorno(filtroInstrutorCultura),
            outros: FiltroPerfil.getRetorno(filtroInstrutorCulturaOutros),
          },
          instrutorEsporte: {
            ...FiltroPerfil.getRetorno(filtroInstrutorEsporte),
            outros: FiltroPerfil.getRetorno(filtroInstrutorEsporteOutros),
          },
        };
        retorno.habilitado = FiltroPerfil.getHabilitado(retorno);
        this.$emit('return', retorno.habilitado ? retorno : null);
      },
      deep: true,
    },
  },
};
</script>
